module.exports = __webpack_public_path__ + "static/dashboard-card-1-06f27227497686336067a9a477bf540f.png";